(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cv-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cvvtLoaded) return;
    window.__cvvtLoaded = true;

    var goalsFired = {};

    function convertGoal(id) {
      if (!id) return;
      window._conv_q = window._conv_q || [];
      window._conv_q.push(['triggerConversion', String(id)]);
    }

    function track(root, name, data) {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: 'cvvt_' + name, cvvt_section: root.dataset.sectionId };
      for (var k in data) payload[k] = data[k];
      window.dataLayer.push(payload);
    }

    function fireGoalOnce(key, id) {
      if (!id || goalsFired[key]) return;
      goalsFired[key] = true;
      convertGoal(id);
    }

    function stopMedia(media) {
      var v = media.querySelector('video');
      if (v) { v.pause(); v.controls = false; }
      var f = media.querySelector('iframe');
      if (f) f.remove();
      media.classList.remove('is-playing');
    }

    function stopAll(except) {
      document.querySelectorAll('.cvvt__media.is-playing').forEach(function (m) {
        if (m !== except) stopMedia(m);
      });
    }

    function init(root) {
      if (!root || root.dataset.cvvtReady) return;
      root.dataset.cvvtReady = '1';

      var trackEl = root.querySelector('.cvvt__track');
      if (!trackEl) return;
      var slides = [].slice.call(root.querySelectorAll('.cvvt__slide'));
      var prev = root.querySelector('[data-cvvt-prev]');
      var next = root.querySelector('[data-cvvt-next]');
      var dotsWrap = root.querySelector('[data-cvvt-dots]');
      var dots = [];

      function step() {
        if (!slides[0]) return 0;
        var gap = parseFloat(getComputedStyle(trackEl).columnGap) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }
      function padLeft() { return parseFloat(getComputedStyle(trackEl).scrollPaddingLeft) || 0; }
      function maxScroll() { return trackEl.scrollWidth - trackEl.clientWidth; }
      function slideLeft(i) {
        var el = slides[Math.max(0, Math.min(i, slides.length - 1))];
        return el ? el.offsetLeft - padLeft() : 0;
      }
      function currentIndex() {
        var s = step();
        return s ? Math.round(trackEl.scrollLeft / s) : 0;
      }

      var settleTimer;
      function settle(left) {
        left = Math.max(0, Math.min(left, maxScroll()));
        trackEl.classList.add('is-settling');
        trackEl.scrollTo({ left: left, behavior: 'smooth' });
        clearTimeout(settleTimer);
        var done = function () {
          clearTimeout(settleTimer);
          trackEl.removeEventListener('scrollend', done);
          trackEl.classList.remove('is-settling');
        };
        trackEl.addEventListener('scrollend', done);
        settleTimer = setTimeout(done, 650);
      }

      function perView() {
        var s = step();
        if (!s) return 1;
        var gap = parseFloat(getComputedStyle(trackEl).columnGap) || 0;
        var visibleW = trackEl.clientWidth - padLeft();
        return Math.max(1, Math.floor((visibleW + gap) / s + 0.01));
      }
      function viewCount() { return Math.max(1, Math.ceil(slides.length / perView())); }
      function viewLeft(p) { return Math.min(slideLeft(p * perView()), maxScroll()); }
      function currentView() {
        var views = viewCount();
        if (trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 2) return views - 1;
        var per = perView();
        return Math.min(views - 1, Math.floor((currentIndex() + per / 2) / per));
      }

      function buildDots() {
        if (!dotsWrap) return;
        var views = viewCount();
        if (views === dots.length) return;
        dotsWrap.innerHTML = '';
        dots = [];
        dotsWrap.hidden = views <= 1;
        for (var p = 0; p < views; p++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cvvt__dot';
          b.setAttribute('aria-label', 'Go to view ' + (p + 1) + ' of ' + views);
          (function (view) {
            b.addEventListener('click', function () { settle(viewLeft(view)); });
          })(p);
          dotsWrap.appendChild(b);
          dots.push(b);
        }
      }

      function update() {
        buildDots();
        var view = currentView();
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === view);
          d.setAttribute('aria-current', i === view ? 'true' : 'false');
        });
        if (prev) prev.disabled = trackEl.scrollLeft <= 2;
        if (next) next.disabled = trackEl.scrollLeft + trackEl.clientWidth >= trackEl.scrollWidth - 2;
      }

      var ticking = false;
      trackEl.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', update);

      if (prev) prev.addEventListener('click', function () { settle(viewLeft(Math.max(0, currentView() - 1))); });
      if (next) next.addEventListener('click', function () { settle(viewLeft(Math.min(viewCount() - 1, currentView() + 1))); });

      var drag = null;
      var suppressClick = false;

      trackEl.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('video[controls], iframe')) return;
        drag = {
          id: e.pointerId, x: e.clientX, left: trackEl.scrollLeft, view: currentView(),
          lastX: e.clientX, lastT: performance.now(), v: 0, moved: false
        };
      });

      trackEl.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x;
        if (!drag.moved) {
          if (Math.abs(dx) < 6) return;
          drag.moved = true;
          clearTimeout(settleTimer);
          trackEl.classList.remove('is-settling');
          trackEl.classList.add('is-dragging');
          try { trackEl.setPointerCapture(e.pointerId); } catch (_) {}
        }
        var now = performance.now();
        var dt = now - drag.lastT;
        if (dt > 0) drag.v = 0.8 * ((e.clientX - drag.lastX) / dt) + 0.2 * drag.v;
        drag.lastX = e.clientX;
        drag.lastT = now;
        trackEl.scrollLeft = drag.left - dx;
        e.preventDefault();
      });

      function endDrag(e) {
        if (!drag || (e && e.pointerId !== drag.id)) return;
        var d = drag;
        drag = null;
        if (!d.moved) return;

        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);

        var v = performance.now() - d.lastT > 80 ? 0 : d.v;
        var s = step() || 1;
        var viewW = s * perView();
        var dist = trackEl.scrollLeft - d.left;
        var threshold = Math.max(30, Math.min(80, s * 0.15));
        var target = d.view;

        if (Math.abs(dist) > threshold) {
          var moves = Math.max(1, Math.round(Math.abs(dist) / viewW));
          target = d.view + (dist > 0 ? moves : -moves);
        } else if (Math.abs(v) > 0.3) {
          target = d.view + (v < 0 ? 1 : -1);
        }
        target = Math.max(0, Math.min(target, viewCount() - 1));

        settle(viewLeft(target));
        trackEl.classList.remove('is-dragging');
      }
      trackEl.addEventListener('pointerup', endDrag);
      trackEl.addEventListener('pointercancel', endDrag);
      trackEl.addEventListener('lostpointercapture', endDrag);

      trackEl.addEventListener('click', function (e) {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      trackEl.addEventListener('dragstart', function (e) { e.preventDefault(); });

      function play(media) {
        stopAll(media);
        var v = media.querySelector('video');
        if (v) {
          v.controls = true;
          v.muted = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
          if (!v.dataset.cvvtBound) {
            v.dataset.cvvtBound = '1';
            v.addEventListener('ended', function () {
              media.classList.remove('is-playing');
              v.controls = false;
              track(root, 'video_complete', { cvvt_index: +media.dataset.index, cvvt_name: media.dataset.title });
            });
          }
        } else if (media.dataset.embed) {
          var f = document.createElement('iframe');
          f.src = media.dataset.embed;
          f.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          f.allowFullscreen = true;
          f.title = media.dataset.title || 'Testimonial video';
          media.appendChild(f);
        }
        media.classList.add('is-playing');
        fireGoalOnce('play', root.dataset.goalPlay);
        track(root, 'video_play', { cvvt_index: +media.dataset.index, cvvt_name: media.dataset.title });
      }

      root.querySelectorAll('.cvvt__media[data-playable]').forEach(function (media) {
        media.addEventListener('click', function () {
          if (media.classList.contains('is-playing')) return;
          play(media);
        });
      });

      root.querySelectorAll('[data-cvvt-cta]').forEach(function (a) {
        a.addEventListener('click', function () {
          fireGoalOnce('cta', root.dataset.goalCta);
          track(root, 'cta_click', {});
        });
      });

      if ('IntersectionObserver' in window) {
        var slideIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.intersectionRatio < 0.5) {
              var m = e.target.querySelector('.cvvt__media.is-playing');
              if (m) stopMedia(m);
            }
          });
        }, { root: trackEl, threshold: [0, 0.5] });
        slides.forEach(function (s) { slideIO.observe(s); });

        var sectionIO = new IntersectionObserver(function (entries) {
          if (entries[0].intersectionRatio < 0.2) {
            root.querySelectorAll('.cvvt__media.is-playing').forEach(stopMedia);
          }
        }, { threshold: [0, 0.2] });
        sectionIO.observe(root);
      }

      update();
    }

    function initAll() { document.querySelectorAll('.cvvt').forEach(init); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.cvvt')); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.cvvt__slide');
      var trackEl = slide && slide.parentElement;
      if (trackEl) {
        var pad = parseFloat(getComputedStyle(trackEl).scrollPaddingLeft) || 0;
        trackEl.scrollTo({ left: slide.offsetLeft - pad, behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(`DOMContentLoaded`, () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isMobile = window.innerWidth <= 768;    
    const swiperElements = document.querySelectorAll('.swiper.hc-testimonial-slider');
    swiperElements.forEach((sliderEl) => {
      const parentSection = sliderEl.closest('.hc___testimonial__trusted__bb');
      if (!parentSection) return;
      const progressFill = parentSection.querySelector('.swiper-pagination-progressbar-fill');
      const thumbEls = parentSection.querySelectorAll('.hc-mobile-thumb');

      let currentScale = 0;
      let targetScale = 0;
      let animationFrameId = null;
      const easingFactor = 0.18; 
      function smoothAnimate() {
        let diff = targetScale - currentScale;
        currentScale += diff * easingFactor;
        if (progressFill) {
          progressFill.style.transform = `translate3d(0px, 0px, 0px) scaleX(${currentScale}) scaleY(1)`;
        }
        if (Math.abs(targetScale - currentScale) > 0.0001) {
          animationFrameId = requestAnimationFrame(smoothAnimate);
        } else {
          currentScale = targetScale;
          if (progressFill) {
            progressFill.style.transform = `translate3d(0px, 0px, 0px) scaleX(${currentScale}) scaleY(1)`;
          }
          animationFrameId = null;
        }
      }
      function updateProgress(progress) {
        targetScale = Math.max(0, Math.min(1, progress));
        if (!animationFrameId) {
          animationFrameId = requestAnimationFrame(smoothAnimate);
        }
      }

      function setActiveThumb(index) {
        thumbEls.forEach((el) => {
          el.classList.toggle('is-active', parseInt(el.dataset.slideIndex, 10) === index);
        });
      }

      const swiperInstance = new Swiper(sliderEl, {
        spaceBetween: 16,
        mousewheel: { forceToAxis: true, thresholdDelta: 35 },
        allowTouchMove: true,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 0.6,
          momentumBounce: false
        },
        slidesPerView: 'auto',
        grabCursor: true,
        keyboard: { enabled: true },
        navigation: { 
          nextEl: parentSection.querySelector('.swiper-button-next'), 
          prevEl: parentSection.querySelector('.swiper-button-prev')
        },
        cssMode: isIOS && isMobile ? true : false,
        on: {
          init: function () {
            updateProgress(this.progress);
            setActiveThumb(this.activeIndex);
          },
          progress: function () {
            updateProgress(this.progress);
          },
          slideChange: function () {
            setActiveThumb(this.activeIndex);
          }
        }
      });

      // Clicking a thumbnail navigates the slider to that slide (mobile only)
      thumbEls.forEach((el) => {
        el.addEventListener('click', () => {
          const idx = parseInt(el.dataset.slideIndex, 10);
          swiperInstance.slideTo(idx);
          setActiveThumb(idx);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-weightloss"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(`DOMContentLoaded`,()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isMobile = window.innerWidth <= 768;    
    let targetSwp = document.querySelector(`.swp____ft___grid`).dataset.swiperObject;
    let RunSwpTargetEl = document.querySelector(`.swp____ft___grid[data-swiper-object="${targetSwp}"]`);
    if( RunSwpTargetEl ){
        new Swiper(RunSwpTargetEl, {
          spaceBetween: 16,
          mousewheel: {forceToAxis: true,thresholdDelta: 35},
          allowTouchMove: true,freeMode: true,slidesPerView: 'auto',grabCursor: true,
          keyboard: { enabled: true },
          cssMode: isIOS && isMobile ? true : false,
        });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medical-leadership"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const plusButtons = document.querySelectorAll('.medlead-plus-btn');
    plusButtons.forEach(button => {
      button.addEventListener('click', function() {
        const imageBox = this.closest('.medlead-image-box');
        if (imageBox) {
          imageBox.classList.toggle('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
